import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function OpportunitiesToggle() {
  const [activeTab, setActiveTab] = useState('STUDY');
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/opportunities?type=${activeTab}&status=OPEN&limit=3`)
      .then((r) => r.json())
      .then((json) => setOpportunities(json.success ? json.data : []))
      .finally(() => setLoading(false));
  }, [activeTab]);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-8">
          <div>
            <h2 className="text-3xl font-bold text-[#00255a] mb-4">Current Study Abroad Opportunities</h2>
            <p className="text-[#64748b] max-w-xl">Browse current international courses, scholarship pathways and overseas job opportunities matched to your goals.</p>
          </div>
          <div className="bg-[#eceef0] p-1.5 rounded-xl inline-flex">
            <button
              onClick={() => setActiveTab('STUDY')}
              className={`px-6 py-2.5 rounded-lg font-bold transition-all ${activeTab === 'STUDY' ? 'bg-white text-[#00255a] shadow-sm' : 'text-[#44474f]'}`}
            >
              Study Abroad Opportunities
            </button>
            <button
              onClick={() => setActiveTab('JOB')}
              className={`px-6 py-2.5 rounded-lg font-bold transition-all ${activeTab === 'JOB' ? 'bg-white text-[#00255a] shadow-sm' : 'text-[#44474f]'}`}
            >
              International Work Placements
            </button>
          </div>
        </div>

        {loading ? (
          <p className="text-[#64748b] text-center py-12">Loading opportunities...</p>
        ) : opportunities.length === 0 ? (
          <p className="text-[#64748b] text-center py-12">No open opportunities right now — check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {opportunities.map((op) => (
              <Link key={op.id} to={`/openings/${op.id}`} className="group cursor-pointer">
                <div className="rounded-2xl overflow-hidden mb-6 h-80 relative bg-[#eceef0]">
                  <img
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    alt={op.country}
                    src={op.imageUrl || `/images/countries/${op.country.toLowerCase().replace(/\s+/g, '-')}.jpg`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1e3c72]/80 to-transparent" />
                  <div className="absolute bottom-6 left-6">
                    <span className="text-white text-xl font-semibold block">{op.title}</span>
                    <p className="text-white/80 text-sm">
                      {op.country}
                      {op.feeFromAmount ? ` · From ${op.feeCurrency} ${op.feeFromAmount}` : ''}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
